import { render, staticRenderFns } from "./bankAccount.vue?vue&type=template&id=55e17b72&"
import script from "./bankAccount.vue?vue&type=script&lang=js&"
export * from "./bankAccount.vue?vue&type=script&lang=js&"
import style0 from "./bankAccount.vue?vue&type=style&index=0&id=55e17b72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports